/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

import type React from 'react';

import { ValidationState } from '../../form';

import type { WizardStep, WizardStepData } from '../interfaces';

export class WizardStepState<T> implements WizardStep<T> {
    id: string;
    tabName: string;
    title: string;
    render: (stepModel: WizardStepData<T>) => React.ReactNode;
    description?: string;
    beforeClose?: (stepModel: WizardStepData<T>) => void;
    validate?: (stepModel: WizardStepData<T>) => boolean|Promise<boolean>;
    isHidden?: (stepModel: WizardStepData<T>) => boolean;
    onBeforeFinish?: (stepModel: WizardStepData<T>) => void;

    prevActionText?: string;
    nextActionText?: string;
    doneActionText?: string;
    cancelActionText?: string;
    disableCancelAction?: boolean;

    stepData: any = {};

    validationState: ValidationState;

    constructor(stepData: WizardStep<T>, validatedChangeHandler: () => void) {
        this.id = stepData.id || this.generateStepId(stepData.title);
        this.tabName = stepData.tabName || stepData.title;
        this.title = stepData.title;
        this.render = stepData.render;
        this.description = stepData.description;
        this.beforeClose = stepData.beforeClose;
        this.validate = (stepModel: WizardStepData<T>) => {
            const isFirsValidate = this.validationState.isCommon();
            this.validationState.markAsForce();

            if (isFirsValidate) {
                validatedChangeHandler();
            }

            return stepData.validate ? stepData.validate(stepModel) : true;
        };
        this.isHidden = stepData.isHidden;
        this.onBeforeFinish = stepData.onBeforeFinish;

        this.prevActionText = stepData.prevActionText;
        this.nextActionText = stepData.nextActionText;
        this.doneActionText = stepData.doneActionText;
        this.cancelActionText = stepData.cancelActionText;
        this.disableCancelAction = stepData.disableCancelAction;

        this.validationState = new ValidationState();
    }

    generateStepId(stepTitle: string): string {
        const idPath = stepTitle.replace(/\s/g, '_').toLowerCase();
        return `${idPath}_${Math.random().toString()}`;
    }
}
